(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["treatments-destination-menu"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('treatments-destination-menu')){
customElements.define('treatments-destination-menu',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;const change=(event)=>{const link=event.target.closest('[data-destination]');if(!link||!this.contains(link))return;const key=link.dataset.destination;this.querySelectorAll('[data-panel]').forEach(panel=>panel.hidden=panel.dataset.panel!==key);this.querySelectorAll('[data-destination]').forEach(item=>item.classList.toggle('is-selected',item===link));};this.addEventListener('pointerover',change);this.addEventListener('focusin',change);}
});}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["treatments-sensory-reels"] && !Shopify.designMode) return;
  try {
    function silenceSensoryVideos(root = document) {
  root.querySelectorAll('.ts-reels video').forEach(video => {
    if (video.dataset.silenced) return;
    video.dataset.silenced = 'true';
    const silence = () => {
      if (!video.muted) video.muted = true;
      if (video.volume !== 0) video.volume = 0;
    };
    video.defaultMuted = true;
    silence();
    video.addEventListener('volumechange', silence);
    video.addEventListener('play', silence);
  });
}
silenceSensoryVideos();
document.addEventListener('shopify:section:load', event => silenceSensoryVideos(event.target));
  } catch(e) { console.error(e); }
})();

})();
